module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BDraft"
  }, [_c('div', {
    staticClass: "allBlogContent"
  }, [_c('v-article', {
    attrs: {
      "articleList": _vm.articleList,
      "articleCount": _vm.articleCount,
      "currentPage": _vm.currentPage,
      "pageNum": _vm.pageNum,
      "isLoading": _vm.isLoading,
      "toEdit": true,
      "isDraft": true
    },
    on: {
      "showMessage": _vm.showMessage
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-372b6c68"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/BAM/view/draft.vue
// module id = 262
// module chunks = 1